import { type DetailSectionProps, DetailsBox } from '@/components/common/details/DetailsBox';
import type { RepositoryResponseDetailed } from '@/hooks/repository';
import { dateTimeFormat } from '@/utility/date';

type Props = {
  repository: RepositoryResponseDetailed;
};

export const RepositoryDetails = ({ repository }: Props) => {
  const repositoryDetailsSections = [
    {
      items: {
        ID: { body: repository.id },
        Created: { body: new Date(repository.createdAt).toLocaleString(dateTimeFormat.local) },
        Updated: { body: new Date(repository.updatedAt).toLocaleString(dateTimeFormat.local) },
        'Image Name': { body: repository.imageName },
      },
    },
  ] as DetailSectionProps[];

  return <DetailsBox sections={repositoryDetailsSections} title={repository.name} />;
};
